import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LessonProvider } from './contexts/LessonContext';
import { OnlineStatusProvider } from './contexts/OnlineStatusContext';
import { OfflineIndicator } from './components/OfflineIndicator';
import LessonView from './components/LessonView';
import './styles/App.css';

const App: React.FC = () => {
  return (
    <Router>
      <OnlineStatusProvider>
        <LessonProvider>
          <div className="App">
            <OfflineIndicator />
            <LessonView />
          </div>
        </LessonProvider>
      </OnlineStatusProvider>
    </Router>
  );
};

export default App; 